import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=5568080a&scoped=true"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"
import style0 from "./Navbar.vue?vue&type=style&index=0&id=5568080a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.30_babel-core@7.0.0-bridge.0_@babel+core@7.29._ce6ff47a1f7c1545485218f930d01bd2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5568080a",
  null
  
)

export default component.exports